module.exports = __webpack_public_path__ + "img/1585221653.963b9020.jpg";